@if (isLoading) {
<div class="loader">
  <img src="/assets/img/loadersillo.gif">
  <p style="font-size: 25px;font-weight: bold;">{{textillo}}</p>
</div>
}